import { Button, Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import React, { useEffect, useState, useRef } from 'react'
import STableLoader from '../skeleton_loader/STableLoader';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { handleExport } from '../../utils/exportFile';
import NoRecordFound from '../NoRecordFound';
import { globalGetService } from '../../utils/globalApiServices';
import { checkApiStatus } from '../../utils';
import { enqueueSnackbar } from 'notistack';


const CostumSummryHeaderHeader = () => (
  <TableHead>
    <TableRow>
      <TableCell align='left'>Sections</TableCell>
      <TableCell align='left'>Include Section</TableCell>
      <TableCell align='left'>Include Remarks</TableCell>
    </TableRow>
  </TableHead>
);

const CostumSummryList = ({ item, onCheckboxChange, checkedList }) => {
  return (
    <TableRow>
      <TableCell align='left'>{item?.name}</TableCell>
      <TableCell align='left'><Checkbox disableRipple size='small' checked={item?.module_checked === true ? true : false}
        onChange={(e) => onCheckboxChange(item.key, 'module_checked', e.target.checked)} /></TableCell>
      <TableCell align='left'><Checkbox disableRipple size='small' checked={item?.remarks_checked === true ? true : false}
        onChange={(e) => onCheckboxChange(item.key, 'remarks_checked', e.target.checked)} disabled={item?.module_checked !== true}
      /></TableCell>
    </TableRow>
  )
};

const CostumLeaseSummaryExport = ({ leaseSummry, onToggleModal }) => {
  const parmas = useParams();
  const { summryList = [], leaseBasicDetails } = useSelector((state) => state.leases);
  const dispatch = useDispatch();
  const [isLoading, setLoading] = useState(false);
  const [exportLoader, setExportLoader] = useState(false);
  const [templateList, setTemplateList] = useState([]);
  const [checkedList, setCheckedList] = useState([]);

  useEffect(() => {
    customTemplateSection(leaseSummry?.data)
  }, []);

  const isExportSuccess = useRef(false);
  useEffect(() => {
    if (isExportSuccess.current && !exportLoader) onToggleModal();
    isExportSuccess.current = exportLoader;
  }, [exportLoader]);

  const templateExport = ({ item }) => {
    const selectedModules = templateList?.filter(i => i?.module_checked);
    const selectedRemarks = templateList?.filter(i => i?.remarks_checked);

    if ((!selectedModules || selectedModules.length === 0) && (!selectedRemarks || selectedRemarks.length === 0)) {
      enqueueSnackbar("Please select at least one section.", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
      return;
    }
    setExportLoader(true);
    const modules = templateList?.filter(item => item?.module_checked)?.map(item => item.key)?.join(',');
    const remarks = templateList?.filter(item => item?.remarks_checked)?.map(item => item.key)?.join(',');

    const query = { modules: modules, remarks: remarks }
    const queryString = new URLSearchParams(query).toString();
    handleExport({
      URL: `lease/${parmas?.leaseSlug}/lease-summary/templates/export/${item?.template_slug}?${queryString ? queryString : ''}`, name: `${leaseBasicDetails?.asset?.name}_Lease` || 'LeaseSummary',
      docType: 'pdf',
      setExportLoader: setExportLoader,
    });
  }

  const customTemplateSection = (item) => {
    setLoading(true);
    globalGetService(`lease/${parmas?.leaseSlug}/lease-summary/templates/${item?.template_slug}/sections`).then(response => {
      // if (checkApiStatus) {
      //   setTemplateList(response?.data?.data?.sections)
      //   setLoading(false)
      // }
      if (checkApiStatus(response)) {
        const sections = response?.data?.data?.sections || [];
        const resetSections = sections.map(section => ({
          ...section,
          module_checked: false,
          remarks_checked: false
        }));

        setTemplateList(resetSections);
        setLoading(false);
      }
    })
  }

  // const handleCheckboxChange = (key, field, value) => {
  //   setTemplateList(p => p.map(option => option?.key === key ? { ...option, [field]: value } : option))
  // };

  const handleCheckboxChange = (key, field, value) => {
    setTemplateList(prev =>
      prev.map(option => {
        if (option?.key !== key) return option;
        if (field === 'module_checked' && value === false) {
          return {
            ...option,
            module_checked: false,
            remarks_checked: false
          };
        }
        return {
          ...option,
          [field]: value
        };
      })
    );
  };

  const isAnyChecked = templateList.some( item => item.module_checked || item.remarks_checked );

  return (
    <Dialog open={leaseSummry?.modal} aria-labelledby="customized-dialog-title" className="add-lease-dialog" maxWidth="sm" fullWidth>
      <DialogTitle sx={{ m: 0, p: 1 }} className="dialog-header"><Typography sx={{marginLeft: '15px'}}>Custom Lease Summary</Typography></DialogTitle>
      <DialogContent dividers>
        <div className='lease-detail-table'>
          <Paper className='table-container system-data'>
            {isLoading ? <STableLoader count={4} rowCount={11} /> : (
              <Table className="mui-table-format" stickyHeader sx={{ m: 0 }}>
                <CostumSummryHeaderHeader />
                <TableBody>
                  {
                    templateList?.length > 0 ? templateList.map((item, index) => (
                      <CostumSummryList item={item} key={index} templateExport={templateExport} exportLoader={exportLoader} onCheckboxChange={handleCheckboxChange} checkedList={checkedList} />
                    )) : <NoRecordFound />
                  }
                </TableBody>
              </Table>
            )}
          </Paper>
        </div>
      </DialogContent>
      <DialogActions sx={{marginRight: "15px"}}>
        <Button className='cancel-btn' variant="outlined" size="small" onClick={onToggleModal}>{isAnyChecked ? "Cancel" : "Close"}</Button>
        {isAnyChecked && <Button className='cancel-btn' variant="outlined" size="small" onClick={() => templateExport({ item: leaseSummry?.data, modules: checkedList })}> {exportLoader ? <CircularProgress color='inherit' size={24} /> : "Export"} </Button> }
      </DialogActions>
    </Dialog>
  )
}

export default CostumLeaseSummaryExport;